import type { DraftAnswers, DraftChoice } from './types.ts';

export type DraftStatus = 'idle' | 'loading-options' | 'answering' | 'generating-script' | 'ready' | 'error';

export type DraftScriptState = {
  idea: string;
  choices: DraftChoice[];
  answers: DraftAnswers;
  title: string;
  script: string;
  status: DraftStatus;
  error: string;
};

export function createInitialDraftState(): DraftScriptState {
  return {
    idea: '',
    choices: [],
    answers: {},
    title: '',
    script: '',
    status: 'idle',
    error: '',
  };
}
